import React, { Component, Fragment } from 'react';
import ButtonCustom from '../components/mini/ButtonCustom';
import { Form, Col, Modal, Button } from 'react-bootstrap';
import { RootContext } from '../Home';
import cx from 'classnames';
import styleRegis from '../pages/RegistrationPage.module.scss';
import { Formik } from 'formik';
import validate from '../pages/validate';
import CustomInput from '../components/mini/CustomInput';
import * as Yup from "yup";
import { requiredField, extractValue } from '../utils/yupHelpers';
import SignaturePad from 'react-signature-canvas';
import $ from 'jquery';
import { isMobile } from "react-device-detect";
import ExampleSign from '../assets/example_sign.jpg';
import Cropper from 'react-easy-crop';
import getCroppedImg from './canvasUtils';
import style from '../pages/CitizenshipPage.module.scss';

import ModalOTP from './mini/ModalOTP';
import axios from "axios";

// import {Modal, Button} from 'react-bootstrap';
// import PDFViewer from 'pdf-viewer-reactjs';

// const CustomNavigation = (props) => {
//     return (
//         <div className='button-control'>
//             <ButtonCustom class="yellow-btn" value="Prev" disabled={props.page === 1 ? true : false} onButtonClick={props.handlePrevClick} />
//             <div style={{display:'inline-block'}}>Page {props.page} / {props.pages}</div>
//             <ButtonCustom class="blue-btn" value="Next" disabled={props.page === props.pages ? true : false} onButtonClick={props.handleNextClick} />
//         </div>
//     )
// }
// function search(nameKey, myArray) {
//     if (myArray) {
//         for (var i = 0; i < myArray.length; i++) {
//             if (myArray[i].value === nameKey) {
//                 return myArray[i];
//             }
//         }
//     }
// }

function rdnBankToBankNameMapping(bankName, rdnBank) {
    let available_rdn_bank = [];
    if(rdnBank) {
        if (bankName === 'bca') {
            available_rdn_bank = ['bca','permata','cimb'].map(v => rdnBank.find(b => b.value === v)).filter(Boolean);
        }

        if (bankName === 'cimb') {
            available_rdn_bank = ['cimb','permata'].map(v => rdnBank.find(b => b.value === v)).filter(Boolean);
        }
        
        if (bankName === 'permata') {
            available_rdn_bank = ['permata','cimb'].map(v => rdnBank.find(b => b.value === v)).filter(Boolean);
        }

        if (bankName === 'bri') {
            available_rdn_bank = ['bri','permata','cimb'].map(v => rdnBank.find(b => b.value === v)).filter(Boolean);
        }

        // A saved Bank Jago choice is what valueBankName holds on mount (see componentDidMount),
        // so it is listed like "other" instead of leaving the select empty.
        if (bankName === 'other' || bankName === 'jago') {
            available_rdn_bank = ['permata','cimb'].map(v => rdnBank.find(b => b.value === v)).filter(Boolean);
        }

        // Bank Jago is offered to every customer bank, last, and only while the options carry it
        const jago = rdnBank.find(b => b.value === 'jago');
        if (jago && ['bca','cimb','permata','bri','other','jago'].includes(bankName)) {
            available_rdn_bank.push(jago);
        }
    }
    return available_rdn_bank;
}

const link_url = (window.location.host === 'openaccount.nhsec.co.id') ? process.env.REACT_APP_LINK_URL_PROD : process.env.REACT_APP_LINK_URL_DEV;
const link_api = (window.location.host === 'openaccount.nhsec.co.id') ? process.env.REACT_APP_BASE_URL_PROD : process.env.REACT_APP_BASE_URL_DEV;

class BankAccountForm extends Component {
    state = {
        // show: false,
        trimmedDataURL: null,
        changeSignature: false,
        tempImgSignature: '',
        dimensions: {
            width: '',
            height: '',
        },
        valueBankName: '',
        valueBankRDNName: '',
        valueBankRDNSyariahName: '',

        showModal: false,
        crop: { x: 0, y: 0 },
        zoom: 2,
        aspect: 7 / 3,
        croppedAreaPixels: null,
        imgCropResult: '',

        showModalOTP: false,
        showModalHasRDN: false,
        bcaRiplayModal: false,
        permataRiplayModal: false,
        permataLivenessUrl: "",
        permataLivenessLoading: false,
        permataLivenessSignatureId: "",
        permataLivenessCompleted: false,
        permataLivenessAttempts: 0,
        permataLivenessMaxReached: false,

        // Phase 8 — Inquiry Risk Rating 자동 호출 결과
        completeLivenessFired: false,        // 중복 호출 가드
        inquiryRiskStatus: null,             // 1=Non High Risk, 2=High Risk, null=미실시/실패
        inquiryFailed: false,                // backend Inquiry 실패 여부
        inquiryLoading: false,
    }

    // Phase 8 — Liveness 통과 후 backend 에 알림 + Inquiry Risk Rating 자동 트리거
    // store 를 명시적으로 받아서 context 접근 문제 회피
    // 0.2.19.2 — member_id 없으면 ktp_number fallback 으로 backend 가 lookup
    triggerInquiry = async (signatureId, store) => {
        const memberId =
            (store && store.state && store.state.member_id) ||
            (store && store.state && store.state.registration && store.state.registration.id) ||
            this.props.memberId;

        const ktpNumber =
            (store && store.state && store.state.registration && store.state.registration.ktp_number) ||
            (store && store.state && store.state.registration && store.state.registration.nik);

        // signature_id 는 필수. member_id OR ktp_number 중 하나만 있으면 진행 가능
        if (!signatureId) {
            console.log('[BankAccountForm.triggerInquiry] SKIP — signature_id missing');
            return;
        }
        if (!memberId && !ktpNumber) {
            console.log('[BankAccountForm.triggerInquiry] SKIP — member_id (' + memberId + ') AND ktp_number missing');
            console.log('  store.state.member_id=' + (store && store.state && store.state.member_id));
            console.log('  store.state.registration.id=' + (store && store.state && store.state.registration && store.state.registration.id));
            console.log('  store.state.registration.ktp_number=' + (store && store.state && store.state.registration && store.state.registration.ktp_number));
            return;
        }

        console.log('[BankAccountForm.triggerInquiry] calling — member_id=' + memberId + ', ktp=' + ktpNumber + ', sig=' + signatureId);
        this.setState({ inquiryLoading: true });
        try {
            const link_api = (window.location.host === 'openaccount.nhsec.co.id')
                ? process.env.REACT_APP_BASE_URL_PROD
                : process.env.REACT_APP_BASE_URL_DEV;
            const res = await axios.post(link_api + '/api/permata/liveness/complete', {
                member_id: memberId || null,
                ktp_number: ktpNumber || null,
                signature_id: signatureId
            });
            if (res.data && res.data.status) {
                const d = res.data.data || {};
                this.setState({
                    inquiryRiskStatus: d.risk_status,    // 1, 2, or null
                    inquiryFailed: !!d.inquiry_failed,
                    inquiryLoading: false,
                });
                console.log('[BankAccountForm] Inquiry result:', d);
            } else {
                this.setState({ inquiryLoading: false, inquiryFailed: true });
            }
        } catch (e) {
            console.error('[BankAccountForm.triggerInquiry] error:', e);
            // Inquiry 실패해도 Submit 진행 가능 (Q2)
            this.setState({ inquiryLoading: false, inquiryFailed: true });
        }
    }

    // Liveness URL prefetch — bank_name_others 선택 시 미리 호출하여 RDN PERMATA 선택 시 즉시 표시
    // SignatureId 는 일단 state 에만 보관하고 setFieldValue 는 Liveness 완료 후에만 (검증 우회 방지)
    fetchPermataLiveness = async (winproId) => {
        // 재시도 시 사용하기 위해 winproId 보관
        this._lastWinproId = winproId;
        // 중복 호출 가드
        if (this.state.permataLivenessUrl) return;
        if (this.state.permataLivenessLoading) return;
        if (this.state.permataLivenessMaxReached) return;
        this.setState({ permataLivenessLoading: true, permataLivenessFailed: false });
        try {
            const response = await axios.post(link_api + '/api/permata/liveness', { winproId: winproId || '' });
            if (response.data && response.data.status) {
                this.setState({
                    permataLivenessUrl: response.data.data.URL,
                    permataLivenessLoading: false,
                    permataLivenessSignatureId: response.data.data.SignatureId  // 임시 보관 — 완료 시 setFieldValue 로 옮김
                });
            } else {
                this.setState({ permataLivenessLoading: false });
            }
        } catch (error) {
            console.log('Permata Liveness fetch error:', error);
            this.setState({ permataLivenessLoading: false });
        }
    }

    // iframe 로드 이벤트 — Permata Liveness SDK 완료 시 success/error URL 로 redirect 됨
    handleLivenessIframeLoad = (setFieldValue, store) => () => {
        try {
            const iframeWin = this.livenessIframeRef && this.livenessIframeRef.contentWindow;
            if (!iframeWin) return;
            // same-origin 인 경우만 location 접근 가능 (success/error.png 는 우리 도메인)
            const href = iframeWin.location.href;
            if (href && (href.indexOf('/permata-liveness-success.html') !== -1 || href.indexOf('/permata-liveness-success.png') !== -1)) {
                // Liveness 통과 — SignatureId 를 Formik 값으로 commit
                if (this.state.permataLivenessSignatureId && typeof setFieldValue === 'function') {
                    setFieldValue('permata_liveness_signature_id', this.state.permataLivenessSignatureId);
                    this.setState({ permataLivenessCompleted: true });

                    // Phase 8: Liveness 통과 즉시 backend 에 알림 → Inquiry Risk Rating 자동 호출
                    // (중복 호출 방지: completeLivenessFired flag)
                    if (!this.state.completeLivenessFired) {
                        this.setState({ completeLivenessFired: true });
                        this.triggerInquiry(this.state.permataLivenessSignatureId, store);
                    }
                }
            } else if (href && (href.indexOf('/permata-liveness-error.html') !== -1 || href.indexOf('/permata-liveness-error.png') !== -1)) {
                // Liveness 실패 — Retry 버튼으로 사용자 명시적 재시도. 5회 제한.
                const nextAttempts = (this.state.permataLivenessAttempts || 0) + 1;
                // telemetry: liveness SDK failures are invisible to the global
                // reporter (cross-origin iframe) — report them explicitly
                if (window.nhReportError) {
                    window.nhReportError('sdk', 'PermataLivenessFailed',
                        'Liveness SDK redirected to error page (attempt ' + nextAttempts + '/5)');
                }
                const MAX_ATTEMPTS = 5;

                this.setState({
                    permataLivenessUrl: '',
                    permataLivenessSignatureId: '',
                    permataLivenessCompleted: false,
                    permataLivenessLoading: false,
                    permataLivenessFailed: true,
                    permataLivenessAttempts: nextAttempts,
                    permataLivenessMaxReached: nextAttempts >= MAX_ATTEMPTS
                });
                if (typeof setFieldValue === 'function') {
                    setFieldValue('permata_liveness_signature_id', '');
                }
                // 5회 도달 시: Retry 버튼도 안 보이게 → 페이지 처음부터 다시
            }
        } catch (e) {
            // cross-origin (Permata SDK 도메인) 인 경우 권한 에러 — 아직 진행 중이라는 뜻, 무시
        }
    }

    handleModalClose = () => {
        this.setState({
            showModal: false
        });
    }

    handleModalShow = () => {
        this.setState({
            showModal: true
        });
    }

    handleModalOTP = (show) => {
        this.setState({showModalOTP: show});
    }

    handleModalHasRDN = (show) => {
        this.setState({showModalHasRDN: show});
    }

    setBcaRiplayModal = (show) => {
        this.setState({bcaRiplayModal: show});
    }

    setPermataRiplayModal = (show) => {
        this.setState({permataRiplayModal: show});
    }

    onCropChange = crop => {
        this.setState({ crop })
    }
    onZoomChange = zoom => {
        this.setState({ zoom })
    }
    onCropComplete = (croppedArea, croppedAreaPixels) => {
        this.setCroppedAreaPixels(croppedAreaPixels);
    }
    setCroppedAreaPixels = (croppedAreaPixels) => {
        this.setState({ croppedAreaPixels })
    }
    cropImage = async () => {
        const croppedImage = await getCroppedImg(this.state.tempImgSignature.src, this.state.croppedAreaPixels)
        this.setState({
            tempImgSignature: {
                ...this.state.tempImgSignature,
                src: croppedImage
            },
            imgCropResult: croppedImage,
        });
        this.handleModalClose();
    }

    sigPad = {}
    clear = () => {
        this.sigPad.clear();
        $('#signature_raw').val('').change();
    }
    trim = () => {
        this.setState({
            trimmedDataURL: this.sigPad.getTrimmedCanvas().toDataURL("image/png")
        }, () => {
            $('#signature_raw').val(this.state.trimmedDataURL).trigger('change').trigger('blur');
        });
    }
    componentDidMount() {
        this.setState({
            dimensions: {
                width: this.container.offsetWidth,
                height: this.container.offsetHeight + 100,
            },
        })

        if (typeof this.props.cur_bank_rdn === 'object') {
            this.setState({
                valueBankName: this.props.cur_bank_rdn.value,
                valueBankRDNName: this.props.cur_bank_rdn.value
            });
        } else {
            this.setState({
                valueBankName: this.props.cur_bank_rdn,
                valueBankRDNName: this.props.cur_bank_rdn
            });
        }

        if (typeof this.props.cur_bank_rdn_syariah === 'object') {
            this.setState({
                valueBankRDNSyariahName: this.props.cur_bank_rdn_syariah.value
            });
        } else {
            this.setState({
                valueBankRDNSyariahName: this.props.cur_bank_rdn_syariah
            });
        }

        if(this.props.hasrdnstat) {
            this.setState({
                showModalHasRDN: true
            });
        }

    }

    render() {
        return (
            <RootContext.Consumer>
                {
                    store => {
                        let company_name = '';
                        if (store.state.setting_web && store.state.setting_web.length > 0) {
                            company_name = store.state.setting_web.find(({ key }) => key === 'company_name').value;
                        }
                        const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });

                        // Yup 검증 — requiredField helper 로 object/string 둘 다 수용 + 빈 값 명시 거부
                        const schema = Yup.object().shape({
                            bank_name: requiredField,

                            bank_name_others: Yup.mixed().when("bank_name", {
                                is: bank => extractValue(bank) === 'other',
                                then: requiredField,
                            }),

                            rdn_bank: Yup.mixed().when([], {
                                is: () => store.state.regulerSubmitted === 0,
                                then: requiredField,
                              }).nullable(),

                              rdn_bank_syariah: Yup.mixed().when([], {
                                is: () => store.state.syariahStat === true,
                                then: requiredField,
                              }).nullable(),

                              permata_agree: Yup.array().when("rdn_bank", {
                                is: (rdn_bank) => {
                                    const v = (rdn_bank && typeof rdn_bank === 'object') ? rdn_bank.value : rdn_bank;
                                    return v === 'permata' && !store.state.hasRDN;
                                },
                                then: Yup.array().min(1, "error_valueMissing").required("error_valueMissing"),
                              }),

                              // Bank Jago consent. No native required on the checkbox: validate() would then
                              // report the generic error_valueMissing over this message.
                              jago_agree: Yup.array().when("rdn_bank", {
                                is: (rdn_bank) => extractValue(rdn_bank) === 'jago',
                                then: Yup.array().min(1, "jago_agree_required").required("jago_agree_required"),
                              }),

                              // BANK LAIN + RDN PERMATA (NTB 시나리오) 일 때만 Liveness 통과 강제
                              permata_liveness_signature_id: Yup.string().when(["bank_name", "rdn_bank"], {
                                is: (bank_name, rdn_bank) => {
                                    const bn = (bank_name && typeof bank_name === 'object') ? bank_name.value : bank_name;
                                    const rb = (rdn_bank && typeof rdn_bank === 'object') ? rdn_bank.value : rdn_bank;
                                    return rb === 'permata' && !store.state.hasRDN;
                                },
                                then: Yup.string().required("error_valueMissing").min(1, "error_valueMissing"),
                              }).nullable(),
                        });

                        return (
                            <>

                            <Formik
                                innerRef={(ref) => { this.formikRef = ref; }}
                                validate={(values) => validate(values, '#bank-account')}
                                validationSchema={schema}
                                onSubmit={values => {
                                    // Phase 8 — High Risk 면 dispatch handler 가 Step 6 (EDD) 로 분기
                                    // Inquiry 실패 (inquiryFailed=true) 시에는 risk_status null → 기존 submit 흐름 (Q2)
                                    const enrichedValues = {
                                        ...values,
                                        _edd_required: (this.state.inquiryRiskStatus === 2 && !this.state.inquiryFailed),
                                        _permata_customer_risk_status: this.state.inquiryRiskStatus,
                                        _permata_inquiry_failed: this.state.inquiryFailed,
                                    };
                                    store.dispatch({ type: 'handleSubmit', field: 'registration_bank_account', values: enrichedValues })
                                }}
                                initialValues={{
                                    bank_name: store.state.registration.bank_name,
                                    bank_name_others: store.state.registration.bank_name_others,
                                    rdn_bank: store.state.registration.rdn_bank,
                                    rdn_bank_syariah: store.state.registration.rdn_bank_syariah,
                                    bank_book_file: store.state.registration.bank_book_file,
                                    account_number: store.state.registration.account_number,
                                    // bank_bic_code: store.state.registration.bank_bic_code,
                                    account_holder_name: store.state.registration.account_holder_name,
                                    npwp_number: store.state.registration.npwp_number,
                                    npwp_registration_date: store.state.registration.npwp_registration_date,
                                    npwp_file: store.state.registration.npwp_file,
                                    account_currency: store.state.registration.account_currency,
                                    signature_raw: store.state.registration.signature_raw,
                                    bca_agree1: store.state.registration.bca_agree1,
                                    bca_agree2: store.state.registration.bca_agree2,
                                    bca_agree3: store.state.registration.bca_agree3,
                                    bca_agree4: store.state.registration.bca_agree4,
                                    permata_agree: store.state.registration.permata_agree || '',
                                    jago_agree: store.state.registration.jago_agree || '',
                                    cimb_agree1: store.state.registration.cimb_agree1,
                                    cimb_agree2: store.state.registration.cimb_agree2,
                                    syariah_tnc_agree: store.state.registration.syariah_tnc_agree,
                                    permata_liveness_signature_id: store.state.permata_liveness_signature_id
                                }}
                            >
                                {({
                                    handleSubmit,
                                    handleChange,
                                    handleBlur,
                                    values,
                                    isSubmitting,
                                    touched,
                                    isValid,
                                    errors,
                                    setFieldValue,
                                    setFieldTouched,
                                }) => (
                                    <Fragment>
                                        <Form id="bank-account" className="form" validated={errors ? false : true} noValidate onSubmit={handleSubmit}>
                                            {
                                                /*
                                                <Form.Row>
                                                    <pre
                                                      className="col-lg-12"
                                                      style={{
                                                        background: '#f6f8fa',
                                                        fontSize: '.65rem',
                                                        padding: '.5rem',
                                                        textAlign: 'left',
                                                        width: '750px',
                                                      }}
                                                    >
                                                      <strong>props</strong> ={' '}
                                                      {JSON.stringify(values, null, 2)}
                                                      <br/>
                                                      <strong>errors</strong> ={' '}
                                                      {JSON.stringify(errors, null, 2)}
                                                      <br/>
                                                      <strong>touched</strong> ={' '}
                                                      {JSON.stringify(touched, null, 2)}
                                                      <br/>
                                                    </pre>
                                                </Form.Row>
                                                */
                                            }
                                            <Form.Row>
                                                <CustomInput
                                                    col="12"
                                                    labelName={store.dispatch({ type: 'translate', 'text': 'bank_name_exists' })}
                                                    name="bank_name"
                                                    type="select"
                                                    required
                                                    value={values.bank_name}
                                                    onChange={async (name, value) => {
                                                        setFieldValue(name, value);

                                                        // reset field yang lain
                                                        setFieldValue('account_holder_name', '');
                                                        setFieldValue('account_number', '');
                                                        setFieldValue('rdn_bank', '');
                                                        setFieldValue('rdn_bank_syariah', '');
                                                        setFieldValue('bank_name_others', '');  // BANK LAIN 의 sub-dropdown 도 초기화 (이전 선택 잔재 제거)

                                                        // 기존 보유 계좌가 BCA/BRI/PERMATA 면 RDN 도 동일 은행으로 자동 선택 (E-KYC 회피)
                                                        // BANK LAIN (other) 인 경우만 사용자가 RDN 직접 선택 (CIMB / PERMATA)
                                                        const _bankValue = (typeof value === 'object') ? value.value : value;
                                                        const _autoSet = (rdnVal) => {
                                                            const rdnOption = (store.state.master.rdn_bank_option || []).find(opt => opt.value === rdnVal);
                                                            setFieldValue('rdn_bank', rdnOption || rdnVal);
                                                            this.setState({ valueBankRDNName: rdnVal });
                                                            // 새 RDN 선택 시 RIPLAY 모달 트리거
                                                            if (rdnVal === 'bca') this.setBcaRiplayModal(true);
                                                            if (rdnVal === 'permata') this.setPermataRiplayModal(true);
                                                        };

                                                        // bank_name 변경 시 Permata 관련 state 완전 초기화 (이전 선택/진행중 잔재 + attempt counter 리셋)
                                                        this.setState({
                                                            permataLivenessUrl: '',
                                                            permataLivenessLoading: false,
                                                            permataLivenessSignatureId: '',
                                                            permataLivenessCompleted: false,
                                                            permataLivenessFailed: false,
                                                            permataLivenessAttempts: 0,
                                                            permataLivenessMaxReached: false
                                                        });
                                                        setFieldValue('permata_liveness_signature_id', '');
                                                        // the Bank Jago consent belongs to that choice, which was just cleared
                                                        setFieldValue('jago_agree', '');

                                                        if (_bankValue === 'bca') {
                                                            this.setState({
                                                                valueBankName: _bankValue,
                                                                valueBankRDNSyariahName: ''
                                                            });
                                                            this.setState({ valueBankRDNName: '' });
                                                        }

                                                        if (_bankValue === 'cimb') {
                                                            this.setState({
                                                                valueBankName: _bankValue,
                                                                valueBankRDNName: '',
                                                                valueBankRDNSyariahName: ''
                                                            });
                                                        }

                                                        if (_bankValue === 'permata') {
                                                            this.setState({
                                                                valueBankName: _bankValue,
                                                                valueBankRDNSyariahName: ''
                                                            });
                                                            this.setState({ valueBankRDNName: '' });
                                                            // ETB(기존 Permata 보유) 가정 — Liveness 호출하지 않음 (E-KYC 회피)
                                                        }

                                                        if (_bankValue === 'bri') {
                                                            this.setState({
                                                                valueBankName: _bankValue,
                                                                valueBankRDNSyariahName: ''
                                                            });
                                                            this.setState({ valueBankRDNName: '' });
                                                        }

                                                        if (_bankValue === 'other') {
                                                            // BANK LAIN — RDN 자동 선택 안 함, 사용자가 bank_name_others + rdn_bank 직접 선택
                                                            this.setState({
                                                                valueBankName: 'other',
                                                                valueBankRDNName: '',
                                                                valueBankRDNSyariahName: ''
                                                            });
                                                        }
                                                    }}
                                                    onBlur={setFieldTouched}
                                                    placeholder={store.dispatch({ type: 'translate', 'text': 'placeholder_select' })}
                                                    error={(typeof errors.bank_name === 'object') ? store.dispatch({ type: 'translate', 'text': errors.bank_name.type }).toString().replace('$param$', errors.bank_name.param).replace('$param2$', errors.bank_name.param2) : store.dispatch({ type: 'translate', 'text': errors.bank_name })}
                                                    touched={touched.bank_name}
                                                    option={store.state.master.bank}
                                                    isDisabled={store.state.hasRDN} 
                                                />
                                            </Form.Row>
                                            {
                                                ((typeof values.bank_name === 'object' && values.bank_name.value === 'other') || values.bank_name === 'other') ?
                                                    <Form.Row>
                                                        <CustomInput
                                                            col="12"
                                                            labelName={store.dispatch({ type: 'translate', 'text': 'bank_name' })}
                                                            name="bank_name_others"
                                                            type="select"
                                                            required
                                                            value={values.bank_name_others}
                                                            onChange={(name, value) => {
                                                                setFieldValue(name, value);

                                                                setFieldValue('account_holder_name', '');
                                                                setFieldValue('account_number', '');
                                                                setFieldValue('rdn_bank', '');

                                                                this.setState({
                                                                    valueBankName: 'other'
                                                                });

                                                                // Permata Liveness URL 미리 가져오기 (사용자가 RDN PERMATA 선택할 가능성 대비)
                                                                this.fetchPermataLiveness(store.state.registration.winpro_id);
                                                            }}
                                                            onBlur={setFieldTouched}
                                                            placeholder={store.dispatch({ type: 'translate', 'text': 'placeholder_select' })}
                                                            error={(typeof errors.bank_name_others === 'object') ? store.dispatch({ type: 'translate', 'text': errors.bank_name_others.type }).toString().replace('$param$', errors.bank_name_others.param).replace('$param2$', errors.bank_name_others.param2) : store.dispatch({ type: 'translate', 'text': errors.bank_name_others })}
                                                            touched={touched.bank_name_others}
                                                            option={store.state.master.bank_list}
                                                        />
                                                    </Form.Row>
                                                    : ''
                                            }
                                            <Form.Row>
                                                <CustomInput
                                                    col="6"
                                                    labelName={store.dispatch({ type: 'translate', 'text': 'account_holder_name' })}
                                                    name="account_holder_name"
                                                    maxLength="50"
                                                    required
                                                    type="text"
                                                    pattern="^[A-Z a-z]+"
                                                    value={values.account_holder_name}
                                                    handleChange={
                                                        (el) => {
                                                            let elVal = el.target.value ? el.target.value.toUpperCase() : "";
                                                            setFieldValue("account_holder_name", elVal);
                                                        }
                                                    }
                                                    isValid={touched.account_holder_name && !errors.account_holder_name}
                                                    isInvalid={!!errors.account_holder_name}
                                                    error={(typeof errors.account_holder_name === 'object') ? store.dispatch({ type: 'translate', 'text': errors.account_holder_name.type }).toString().replace('$param$', errors.account_holder_name.param).replace('$param2$', errors.account_holder_name.param2) : store.dispatch({ type: 'translate', 'text': errors.account_holder_name })}
                                                    disabled={store.state.hasRDN}
                                                />
                                                <CustomInput
                                                    col="6"
                                                    labelName={store.dispatch({ type: 'translate', 'text': 'account_number' })}
                                                    name="account_number"
                                                    type="text"
                                                    maxLength={((typeof values.bank_name === 'object' && values.bank_name.value === 'bca') || values.bank_name === 'bca') ? '10' : '16'}
                                                    minLength="9"
                                                    required
                                                    pattern="^[0-9]*$"
                                                    value={values.account_number}
                                                    handleChange={handleChange}
                                                    isValid={touched.account_number && !errors.account_number}
                                                    isInvalid={!!errors.account_number}
                                                    error={(typeof errors.account_number === 'object') ? store.dispatch({ type: 'translate', 'text': errors.account_number.type }).toString().replace('$param$', errors.account_number.param).replace('$param2$', errors.account_number.param2) : store.dispatch({ type: 'translate', 'text': errors.account_number })}
                                                    disabled={store.state.hasRDN}
                                                />
                                            </Form.Row>
                                            
                                            {
                                                    <Form.Row>
                                                        <CustomInput
                                                            col="12"
                                                            labelName="RDN Bank"
                                                            name="rdn_bank"
                                                            type="select"
                                                            required
                                                            value={values.rdn_bank}
                                                            onChange={async (name, value) => {
                                                                setFieldValue(name, value);
                                                                const _rdnVal = (typeof value === 'object') ? value.value : value;
                                                                this.setState({
                                                                    valueBankRDNName: _rdnVal
                                                                });
                                                                if (_rdnVal === "bca") this.setBcaRiplayModal(true);
                                                                if (_rdnVal === "permata") this.setPermataRiplayModal(true);
                                                                // consent given for Bank Jago does not carry over to another bank
                                                                if (_rdnVal !== 'jago') setFieldValue('jago_agree', '');

                                                                // BANK LAIN + RDN=PERMATA 조합일 때만 Liveness 호출 (NTB 시나리오)
                                                                const _bankNameVal = (values.bank_name && typeof values.bank_name === 'object')
                                                                    ? values.bank_name.value
                                                                    : values.bank_name;
                                                                if (_rdnVal === 'permata') {
                                                                    // bank_name_others 단계에서 prefetch 했으면 즉시 사용; 아니면 지금 호출 (fallback)
                                                                    this.fetchPermataLiveness(store.state.registration.winpro_id);
                                                                } else {
                                                                    // 다른 조합이면 Liveness 정보 초기화
                                                                    this.setState({
                                                                        permataLivenessUrl: '',
                                                                        permataLivenessLoading: false,
                                                                        permataLivenessSignatureId: '',
                                                                        permataLivenessCompleted: false
                                                                    });
                                                                    setFieldValue('permata_liveness_signature_id', '');
                                                                }
                                                            }}
                                                            onBlur={setFieldTouched}
                                                            placeholder={store.dispatch({ type: 'translate', 'text': 'placeholder_select' })}
                                                            error={(typeof errors.rdn_bank === 'object') ? store.dispatch({ type: 'translate', 'text': errors.rdn_bank.type }).toString().replace('$param$', errors.rdn_bank.param).replace('$param2$', errors.rdn_bank.param2) : store.dispatch({ type: 'translate', 'text': errors.rdn_bank })}
                                                            touched={touched.rdn_bank}
                                                            option={ rdnBankToBankNameMapping(this.state.valueBankName, store.state.master.rdn_bank_option)}
                                                            isDisabled={store.state.hasRDN}
                                                        />
                                                    </Form.Row>
                                            }

                                            {
                                                // jika akun baru yang belum punya sre dan rdn reguler tapi mendaftar via /syariah
                                                // maka sekaligus dibuat akun syariahnya
                                                (store.state.syariahStat) ?
                                                    <Form.Row>
                                                        <CustomInput
                                                            col="12"
                                                            labelName="RDN SYARIAH"
                                                            name="rdn_bank_syariah"
                                                            type="select"
                                                            required
                                                            value={values.rdn_bank_syariah}
                                                            onChange={(name, value) => {
                                                                setFieldValue(name, value);
                                                                this.setState({
                                                                    valueBankRDNSyariahName: (typeof value === 'object') ? value.value : value
                                                                })
                                                            }}
                                                            onBlur={setFieldTouched}
                                                            placeholder={store.dispatch({ type: 'translate', 'text': 'placeholder_select' })}
                                                            error={(typeof errors.rdn_bank_syariah === 'object') ? store.dispatch({ type: 'translate', 'text': errors.rdn_bank_syariah.type }).toString().replace('$param$', errors.rdn_bank_syariah.param).replace('$param2$', errors.rdn_bank_syariah.param2) : store.dispatch({ type: 'translate', 'text': errors.rdn_bank_syariah })}
                                                            touched={touched.rdn_bank_syariah}
                                                            option={store.state.master.rdn_bank_option_syariah}
                                                        />
                                                    </Form.Row>
                                                    : ''
                                            }                                            

                                            <Form.Row>
                                                <div className="information-bca col-12">
                                                    <strong>{store.dispatch({ type: 'translate', 'text': 'label_information' })}: </strong>
                                                    {/* {renderHTML(store.dispatch({ 'type': 'translate', 'text': 'information_bca' }))} */}
                                                    {renderHTML(store.dispatch({ 'type': 'translate', 'text': 'information_rdn' }))}
                                                </div>
                                                {
                                                    // (this.state.valueBankName) ? 
                                                    // (this.state.valueBankName === 'bca') ?
                                                    // <div className="information-bca">
                                                    //     <strong>{store.dispatch({type:'translate', 'text': 'label_information'})}: </strong>{renderHTML(store.dispatch({'type':'translate', 'text': 'information_bca'}))}
                                                    // </div>
                                                    // :
                                                    // <div className="information-bca">
                                                    //     <strong>{store.dispatch({type:'translate', 'text': 'label_information'})}: </strong>{renderHTML(store.dispatch({'type':'translate', 'text': 'information_nonbca'}))}
                                                    // </div>
                                                    // : ''
                                                }
                                            </Form.Row>
                                            <Form.Row>
                                                <CustomInput
                                                    col="6"
                                                    labelName={store.dispatch({ type: 'translate', 'text': 'bank_book_file' })}
                                                    name="bank_book_file"
                                                    type="file"
                                                    accept="image/jpg,image/png,image/jpeg"
                                                    capture
                                                    required={!store.state.registration.bank_book_path && !values.bank_book_file ? true : false}
                                                    exists={store.state.registration.bank_book_path}
                                                    handleChange={(file, imgTemp) => setFieldValue('bank_book_file', file)}
                                                    isValid={touched.bank_book_file && !errors.bank_book_file}
                                                    isInvalid={!!errors.bank_book_file}
                                                    error={(typeof errors.bank_book_file === 'object') ? store.dispatch({ type: 'translate', 'text': errors.bank_book_file.type }).toString().replace('$param$', errors.bank_book_file.param).replace('$param2$', errors.bank_book_file.param2) : store.dispatch({ type: 'translate', 'text': errors.bank_book_file })}
                                                />
                                            </Form.Row>
                                            {/* iframe 조건 만족 시 — Liveness URL 자동 fetch (prefill 또는 재진입 대응) */}
                                            {(((true))
                                              && ((values?.rdn_bank === "permata" || values?.rdn_bank?.value === "permata"))
                                              && !this.state.permataLivenessUrl
                                              && !this.state.permataLivenessLoading
                                              && !this.state.permataLivenessMaxReached
                                              && !this.state.permataLivenessFailed
                                              && (() => {
                                                  // setState during render 회피 — setTimeout 으로 다음 tick 에 호출
                                                  setTimeout(() => {
                                                      this.fetchPermataLiveness(store.state.registration.winpro_id);
                                                  }, 0);
                                                  return false;  // 아무것도 렌더하지 않음
                                              })())}

                                            {/* Liveness iframe — BANK LAIN + RDN PERMATA 조합 (NTB) 일 때만 노출 */}
                                            {(((true))
                                              && ((values?.rdn_bank === "permata" || values?.rdn_bank?.value === "permata"))) && (
                                                <Form.Row>
                                                    <Form.Group as={Col} lg={12}>
                                                        <Form.Label>
                                                            {store.dispatch({ type: 'translate', 'text': 'permata_liveness' })}
                                                            <small className="required form-text">* </small>
                                                        </Form.Label>
                                                        <div style={{
                                                            background: '#f5faff',
                                                            border: '1px solid #cfe3f7',
                                                            borderRadius: 6,
                                                            padding: '10px 14px',
                                                            marginBottom: 10,
                                                            fontSize: 13,
                                                            color: '#0d47a1',
                                                            lineHeight: 1.5,
                                                            maxWidth: 480
                                                        }}>
                                                            <strong>Mengapa Liveness Detection ini wajib? / Why is Liveness Detection required?</strong><br/>
                                                            Anda akan membuka rekening RDN baru di <strong>PT Bank Permata Tbk</strong>. Sesuai regulasi e-KYC Bank Permata, calon nasabah baru wajib menjalani Liveness Detection (verifikasi keaslian wajah secara langsung) untuk memastikan bahwa Anda adalah orang sungguhan dan bukan foto atau rekaman video.<br/>
                                                            <em>You are opening a new RDN account at PT Bank Permata Tbk. As required by Permata Bank's e-KYC regulation, new customers must complete Liveness Detection (live face authenticity verification) to confirm that you are a real person and not a photo or video recording.</em>
                                                        </div>
                                                        <div style={{
                                                            width: '100%',
                                                            maxWidth: 480,
                                                            // 모바일에서 화면 70% 이내로 제한, 데스크톱에서 600px 까지 — 작은 화면에서 잘림 방지
                                                            height: 'min(600px, 70vh)',
                                                            minHeight: 380,
                                                            overflow: 'hidden',
                                                            borderRadius: 6,
                                                            border: '1px solid #e0e0e0',
                                                            background: '#fafafa',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            position: 'relative'
                                                        }}>
                                                            {this.state.permataLivenessUrl ? (
                                                                <iframe
                                                                    ref={(el) => { this.livenessIframeRef = el; }}
                                                                    title="Permata Liveness"
                                                                    src={this.state.permataLivenessUrl}
                                                                    allow="camera *; microphone *; fullscreen *; display-capture *"
                                                                    referrerPolicy="strict-origin-when-cross-origin"
                                                                    scrolling="no"
                                                                    onLoad={this.handleLivenessIframeLoad(setFieldValue, store)}
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%',
                                                                        border: 'none',
                                                                        display: 'block'
                                                                    }}
                                                                />
                                                            ) : (
                                                                <div style={{ textAlign: 'center', color: '#666' }}>
                                                                    <div className="spinner-border text-primary" role="status" style={{ width: 40, height: 40 }}>
                                                                        <span className="sr-only">Loading...</span>
                                                                    </div>
                                                                    <div style={{ marginTop: 12, fontSize: 13 }}>
                                                                        Mempersiapkan Liveness Detection...<br/>
                                                                        <em>Preparing Liveness Detection...</em>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* DEV ONLY — Liveness 우회 버튼
                                                            보안: 운영 build 에서는 .env 에 REACT_APP_ALLOW_LIVENESS_BYPASS 미설정 →
                                                            webpack terser 가 false 조건의 JSX 블록 전체를 dead code 로 제거 →
                                                            production bundle 에는 코드 자체가 포함되지 않음 */}
                                                        {process.env.REACT_APP_ALLOW_LIVENESS_BYPASS === 'true'
                                                            && window.location.host !== 'openaccount.nhsec.co.id'
                                                            && !this.state.permataLivenessCompleted && (
                                                            <div style={{ marginTop: 10, padding: 10, background: '#fff8dc', border: '2px dashed #d4a017', borderRadius: 4 }}>
                                                                <strong style={{ color: '#a06800' }}>🛠 DEV TEST ONLY</strong>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        const fakeSigId = 'dev_skip_' + Date.now();
                                                                        setFieldValue('permata_liveness_signature_id', fakeSigId);
                                                                        this.setState({
                                                                            permataLivenessSignatureId: fakeSigId,
                                                                            permataLivenessCompleted: true,
                                                                            permataLivenessUrl: '',
                                                                            permataLivenessLoading: false,
                                                                            permataLivenessFailed: false,
                                                                        });
                                                                        if (!this.state.completeLivenessFired) {
                                                                            this.setState({ completeLivenessFired: true });
                                                                            this.triggerInquiry(fakeSigId, store);
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        marginLeft: 10,
                                                                        padding: '5px 15px',
                                                                        background: '#d4a017',
                                                                        color: '#fff',
                                                                        border: 'none',
                                                                        borderRadius: 3,
                                                                        cursor: 'pointer',
                                                                        fontWeight: 'bold'
                                                                    }}
                                                                >
                                                                    Skip Liveness (Dev Only)
                                                                </button>
                                                                <div style={{ fontSize: 11, color: '#a06800', marginTop: 5 }}>
                                                                    개발 환경에서만 표시 — Liveness 우회 후 Inquiry Risk Rating 자동 호출
                                                                </div>
                                                            </div>
                                                        )}
                                                        {/* Liveness 실패 시 Retry 버튼 (5회 제한) */}
                                                        {this.state.permataLivenessFailed && !this.state.permataLivenessMaxReached && (
                                                            <div style={{ marginTop: 10, padding: '10px 14px', background: '#fff4f4', border: '1px solid #f5c6cb', borderRadius: 6, maxWidth: 480 }}>
                                                                <div style={{ color: '#c62828', fontSize: 13, marginBottom: 8 }}>
                                                                    Liveness Detection gagal. Silakan coba lagi. ({this.state.permataLivenessAttempts}/5)<br/>
                                                                    <em>Liveness Detection failed. Please try again. ({this.state.permataLivenessAttempts}/5)</em>
                                                                </div>
                                                                <Button variant="primary" size="sm" onClick={() => this.fetchPermataLiveness(this._lastWinproId || store.state.registration.winpro_id)}>
                                                                    Coba Lagi / Retry
                                                                </Button>
                                                            </div>
                                                        )}
                                                        {/* 5회 도달 시 — 더 이상 재시도 불가 안내 */}
                                                        {this.state.permataLivenessMaxReached && (
                                                            <div style={{ marginTop: 10, padding: '10px 14px', background: '#fff4f4', border: '1px solid #f5c6cb', borderRadius: 6, color: '#b71c1c', fontSize: 13, maxWidth: 480 }}>
                                                                <strong>Batas percobaan tercapai (5/5).</strong><br/>
                                                                Anda telah mencapai batas maksimum percobaan Liveness Detection. Silakan muat ulang halaman dan mulai pendaftaran dari awal.<br/><br/>
                                                                <em><strong>Maximum attempts reached (5/5).</strong></em><br/>
                                                                <em>Please reload the page and restart your registration.</em>
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Form.Row>
                                            )}
                                            {
                                                ((typeof values.rdn_bank === 'object' && values.rdn_bank.value === 'mandiri') || values.rdn_bank === 'mandiri') ?
                                                    <Form.Row>
                                                        <CustomInput
                                                            col="4"
                                                            labelName={store.dispatch({ type: 'translate', 'text': 'npwp_number' })}
                                                            name="npwp_number"
                                                            type="text"
                                                            maxLength="15"
                                                            minLength="15"
                                                            pattern="^[0-9]*$"
                                                            required={true}
                                                            value={values.npwp_number}
                                                            handleChange={handleChange}
                                                            isValid={touched.npwp_number && !errors.npwp_number}
                                                            isInvalid={!!errors.npwp_number}
                                                            error={(typeof errors.npwp_number === 'object') ? store.dispatch({ type: 'translate', 'text': errors.npwp_number.type }).toString().replace('$param$', errors.npwp_number.param).replace('$param2$', errors.npwp_number.param2) : store.dispatch({ type: 'translate', 'text': errors.npwp_number })}
                                                        />
                                                        <CustomInput
                                                            col="4"
                                                            labelName={store.dispatch({ type: 'translate', 'text': 'npwp_file' })}
                                                            name="npwp_file"
                                                            type="file"
                                                            accept="image/jpg,image/png,image/jpeg"
                                                            capture
                                                            required={!store.state.registration.npwp_path && !values.npwp_file ? true : false}
                                                            exists={store.state.registration.npwp_path}
                                                            handleChange={(file) => setFieldValue('npwp_file', file)}
                                                            isValid={touched.npwp_file && !errors.npwp_file}
                                                            isInvalid={!!errors.npwp_file}
                                                            error={(typeof errors.npwp_file === 'object') ? store.dispatch({ type: 'translate', 'text': errors.npwp_file.type }).toString().replace('$param$', errors.npwp_file.param).replace('$param2$', errors.npwp_file.param2) : store.dispatch({ type: 'translate', 'text': errors.npwp_file })}
                                                        />
                                                        <CustomInput
                                                            col="4"
                                                            labelName={store.dispatch({ type: 'translate', 'text': 'npwp_registration_date' })}
                                                            name="npwp_registration_date"
                                                            type="date"
                                                            required={true}
                                                            dateType="registerdate"
                                                            value={values.npwp_registration_date}
                                                            handleChange={date => setFieldValue('npwp_registration_date', date)}
                                                            isValid={touched.npwp_registration_date && !errors.npwp_registration_date}
                                                            isInvalid={!!errors.npwp_registration_date}
                                                            error={(typeof errors.npwp_registration_date === 'object') ? store.dispatch({ type: 'translate', 'text': errors.npwp_registration_date.type }).toString().replace('$param$', errors.npwp_registration_date.param).replace('$param2$', errors.npwp_registration_date.param2) : store.dispatch({ type: 'translate', 'text': errors.npwp_registration_date })}
                                                            placeholder="DD/MM/YYYY"
                                                        />
                                                    </Form.Row>
                                                    : ''
                                            }

                                            <Form.Row>
                                                <Form.Group as={Col} lg={12} className="form-group" ref={el => (this.container = el)}>
                                                    <Form.Label className="form-label">
                                                        {store.dispatch({ type: 'translate', 'text': 'signature' })}
                                                        <Form.Text className="required">* </Form.Text>
                                                        <Form.Text className="info">{store.dispatch({ type: 'translate', 'text': 'signature_info' })}</Form.Text>
                                                    </Form.Label>
                                                    <input id="signature_raw" type="text"
                                                        style={{ display: 'none' }}
                                                        name="signature_raw"
                                                        value={values.signature_raw}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        required={!store.state.registration.signature_path || this.state.changeSignature}
                                                        className="form-control"
                                                    />
                                                    {
                                                        errors.signature_raw && !values.signature_raw && <div className="invalid-feedback">{(typeof errors.signature_raw === 'object') ? store.dispatch({ type: 'translate', 'text': errors.signature_raw.type }).toString().replace('$param$', errors.signature_raw.param).replace('$param2$', errors.signature_raw.param2) : store.dispatch({ type: 'translate', 'text': errors.signature_raw })}</div>
                                                    }

                                                    <div className="wrap-signature">
                                                        {
                                                            store.state.registration.signature_path && !this.state.tempImgSignature && !this.state.changeSignature ?
                                                                <Fragment>
                                                                    <img alt={store.state.registration.first_name} src={link_url + store.state.registration.signature_path.split("/home/openaccount/").pop() + '?show=' + Math.floor(Math.random() * 200)} className="img-thumbnail" />
                                                                    <div className="navigate-signature-exists">
                                                                        <ButtonCustom value={store.dispatch({ type: 'translate', 'text': 'btn_change' })} styleCustom="blue-btn" onButtonClick={(value) => this.setState({ changeSignature: true })} />
                                                                    </div>
                                                                </Fragment>
                                                                :
                                                                this.state.tempImgSignature && !this.state.changeSignature ?
                                                                    <Fragment>
                                                                        <img alt={this.state.tempImgSignature.alt} src={this.state.tempImgSignature.src} className="img-thumbnail" />
                                                                        <div className="navigate-signature-exists">
                                                                            <ButtonCustom value={store.dispatch({ type: 'translate', 'text': 'btn_change' })} styleCustom="blue-btn" onButtonClick={(value) => { this.setState({ changeSignature: true, tempImgSignature: '' }); setFieldValue('signature_raw', ''); }} />
                                                                        </div>
                                                                    </Fragment>
                                                                    :
                                                                    <Fragment>
                                                                        <SignaturePad
                                                                            penColor='black'
                                                                            canvasProps={{
                                                                                width: this.state.dimensions.width - 30,
                                                                                height: 250,
                                                                                className: 'sigCanvas',
                                                                                style: { touchAction: 'none' }, // 모바일 페이지 스크롤이 서명 입력 가로채는 것 방지
                                                                            }}
                                                                            onEnd={(value) => {
                                                                                setFieldValue('signature_raw', this.sigPad.getTrimmedCanvas().toDataURL("image/png"));
                                                                            }
                                                                            }
                                                                            ref={(ref) => { this.sigPad = ref }}
                                                                        />
                                                                        <div className="navigate-signature">
                                                                            <ButtonCustom value={store.dispatch({ type: 'translate', 'text': 'btn_clear' })} styleCustom="blue-btn" onButtonClick={(value) => { this.clear(); setFieldValue('signature_raw', ''); }} />
                                                                            {
                                                                                store.state.registration.signature_path ?
                                                                                    <ButtonCustom value={store.dispatch({ type: 'translate', 'text': 'btn_cancel' })} styleCustom="yellow-btn" onButtonClick={(value) => { this.setState({ changeSignature: false }); setFieldValue('signature_raw', '') }} />
                                                                                    : ''
                                                                            }
                                                                            <input id="sig-choose" type="file"
                                                                                accept="image/jpg,image/png,image/jpeg" capture name="signature_file"
                                                                                style={{ display: 'none' }}
                                                                                onChange={(event) => {
                                                                                    if (event.currentTarget.files.length > 0) {
                                                                                        const reader = new FileReader();
                                                                                        const name = event.currentTarget.files[0].name;
                                                                                        reader.onloadend = () => {
                                                                                            if (reader.readyState === 2) {
                                                                                                this.setState({
                                                                                                    tempImgSignature: {
                                                                                                        src: reader.result,
                                                                                                        alt: name
                                                                                                    },
                                                                                                })
                                                                                            }
                                                                                        }
                                                                                        reader.readAsDataURL(event.currentTarget.files[0]);
                                                                                        // setFieldValue('signature_raw', event.currentTarget.files[0]);
                                                                                        // setFieldTouched('signature_raw', true);
                                                                                        this.setState({ changeSignature: false });
                                                                                        this.handleModalShow();
                                                                                    }
                                                                                }
                                                                                }
                                                                            />
                                                                            <ButtonCustom style={{ float: 'right' }} value={store.dispatch({ type: 'translate', 'text': 'btn_choosefile' })} styleCustom="blue-btn" onButtonClick={(value) => { document.getElementById('sig-choose').click() }} />
                                                                        </div>
                                                                    </Fragment>
                                                        }
                                                        {(this.state.imgCropResult && this.state.imgCropResult !== values.signature_raw) ? setFieldValue('signature_raw', this.state.imgCropResult) : ''}
                                                        <Modal size="lg" centered show={this.state.showModal} onHide={this.handleModalClose} backdrop="static" keyboard={false}>
                                                            <Modal.Body>
                                                                <div style={{ position: 'relative', display: 'block', width: '100%', height: '500px' }}>
                                                                    <Cropper
                                                                        image={this.state.tempImgSignature.src}
                                                                        crop={this.state.crop}
                                                                        zoom={this.state.zoom}
                                                                        aspect={this.state.aspect}
                                                                        onCropChange={this.onCropChange}
                                                                        onCropComplete={this.onCropComplete}
                                                                        onZoomChange={this.onZoomChange}
                                                                    />
                                                                </div>
                                                                <div style={{
                                                                    padding: '20px 0',
                                                                }}>
                                                                    <Form.Control type="range" value={this.state.zoom} onChange={(e) => this.onZoomChange(e.currentTarget.value)} custom min="1" max="3" step="0.1" />
                                                                </div>
                                                            </Modal.Body>
                                                            <Modal.Footer>
                                                                <Button variant="primary" onClick={() => { this.cropImage(); console.log(this.state.imgCropResult) }}>Crop</Button>
                                                            </Modal.Footer>
                                                        </Modal>
                                                    </div>
                                                    <div className="wrap-example sign">
                                                        <Form.Text className="info">
                                                            <small>
                                                                <strong>{store.dispatch({ type: 'translate', 'text': 'label_attention' })}: </strong>
                                                                {renderHTML(store.dispatch({ type: 'translate', 'text': 'example_sign_info_text' }))}
                                                            </small>
                                                        </Form.Text>
                                                        <img src={ExampleSign}
                                                            alt="example"
                                                            className="img-thumbnail"
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Form.Row>

                                            {
                                                (this.state.valueBankRDNName && this.state.valueBankRDNName === 'bca' && !store.state.hasRDN) ?
                                                    <Form.Row>
                                                        <CustomInput
                                                            col="12"
                                                            required
                                                            name="bca_agree1"
                                                            type="checkbox"
                                                            typeCheck="single"
                                                            value={values.bca_agree1}
                                                            option={[{ value: 0, label: store.dispatch({ type: 'translate', 'text': 'bca_agree1_a' }) + company_name + store.dispatch({ type: 'translate', 'text': 'bca_agree1_b' }) }]}
                                                            handleChange={handleChange}
                                                            isValid={touched.bca_agree1 && !errors.bca_agree1}
                                                            isInvalid={!!errors.bca_agree1}
                                                            error={(typeof errors.bca_agree1 === 'object') ? store.dispatch({ type: 'translate', 'text': errors.bca_agree1.type }).toString().replace('$param$', errors.bca_agree1.param).replace('$param2$', errors.bca_agree1.param2) : store.dispatch({ type: 'translate', 'text': errors.bca_agree1 })}
                                                        />
                                                        <CustomInput
                                                            col="12"
                                                            required
                                                            name="bca_agree2"
                                                            type="checkbox"
                                                            typeCheck="single"
                                                            value={values.bca_agree2}
                                                            option={[{ value: 0, label: (<div>{store.dispatch({ type: 'translate', 'text': 'bca_agree2' })} <a target="_blank" rel="noopener noreferrer" href="/viewer/bca-rdn-statements" style={{ 'fontWeight': 'bold', 'fontStyle': 'italic', 'color': '#0172ba', 'textDecoration': 'none', 'paddingBottom': '1px', 'borderBottom': '1px solid transparent', 'transition': 'all 0.5s' }}>{store.dispatch({ type: 'translate', 'text': 'state_here' })}</a></div>) }]}
                                                            handleChange={handleChange}
                                                            isValid={touched.bca_agree2 && !errors.bca_agree2}
                                                            isInvalid={!!errors.bca_agree2}
                                                            error={(typeof errors.bca_agree2 === 'object') ? store.dispatch({ type: 'translate', 'text': errors.bca_agree2.type }).toString().replace('$param$', errors.bca_agree2.param).replace('$param2$', errors.bca_agree2.param2) : store.dispatch({ type: 'translate', 'text': errors.bca_agree2 })}
                                                        />
                                                        <CustomInput
                                                            col="12"
                                                            required
                                                            name="bca_agree3"
                                                            type="checkbox"
                                                            typeCheck="single"
                                                            value={values.bca_agree3}
                                                            option={[{ value: 0, label: (<div>{store.dispatch({ type: 'translate', 'text': 'bca_agree3_a' })} <a target="_blank" href="/viewer/bca-tapres-terms-and-conditions" style={{ 'fontWeight': 'bold', 'fontStyle': 'italic', 'color': '#0172ba', 'textDecoration': 'none', 'paddingBottom': '1px', 'borderBottom': '1px solid transparent', 'transition': 'all 0.5s' }}>{store.dispatch({ type: 'translate', 'text': 'state_here' })}</a>{store.dispatch({ type: 'translate', 'text': 'bca_agree3_b' })} <a target="_blank" href="/viewer/bca-rdn-additional-terms" style={{ 'fontWeight': 'bold', 'fontStyle': 'italic', 'color': '#0172ba', 'textDecoration': 'none', 'paddingBottom': '1px', 'borderBottom': '1px solid transparent', 'transition': 'all 0.5s' }}>{store.dispatch({ type: 'translate', 'text': 'state_here' })}</a>{store.dispatch({ type: 'translate', 'text': 'bca_agree3_c' })} <a target="_blank" href="/viewer/bca-rdn-estatement-terms" style={{ 'fontWeight': 'bold', 'fontStyle': 'italic', 'color': '#0172ba', 'textDecoration': 'none', 'paddingBottom': '1px', 'borderBottom': '1px solid transparent', 'transition': 'all 0.5s' }}>{store.dispatch({ type: 'translate', 'text': 'state_here' })}</a></div>) }]}
                                                            handleChange={handleChange}
                                                            isValid={touched.bca_agree3 && !errors.bca_agree3}
                                                            isInvalid={!!errors.bca_agree3}
                                                            error={(typeof errors.bca_agree3 === 'object') ? store.dispatch({ type: 'translate', 'text': errors.bca_agree3.type }).toString().replace('$param$', errors.bca_agree3.param).replace('$param2$', errors.bca_agree3.param2) : store.dispatch({ type: 'translate', 'text': errors.bca_agree3 })}
                                                        />
                                                        <CustomInput
                                                            col="12"
                                                            required
                                                            name="bca_agree4"
                                                            type="checkbox"
                                                            typeCheck="single"
                                                            value={values.bca_agree4}
                                                            option={[{ value: 0, label: (<div>{store.dispatch({ type: 'translate', 'text': 'bca_agree4' })} <a target="_blank" href="/viewer/bca-rdn-riplay" style={{ 'fontWeight': 'bold', 'fontStyle': 'italic', 'color': '#0172ba', 'textDecoration': 'none', 'paddingBottom': '1px', 'borderBottom': '1px solid transparent', 'transition': 'all 0.5s' }}>{store.dispatch({ type: 'translate', 'text': 'state_here' })}</a></div>) }]}
                                                            handleChange={handleChange}
                                                            isValid={touched.bca_agree4 && !errors.bca_agree4}
                                                            isInvalid={!!errors.bca_agree4}
                                                            error={(typeof errors.bca_agree4 === 'object') ? store.dispatch({ type: 'translate', 'text': errors.bca_agree4.type }).toString().replace('$param$', errors.bca_agree4.param).replace('$param2$', errors.bca_agree4.param2) : store.dispatch({ type: 'translate', 'text': errors.bca_agree4 })}
                                                        />
                                                    </Form.Row>
                                                    : ''

                                            }

                                            { /* PERMATA AGREEMENT CHECKBOX (RIPLAY 동의) */ }
                                            {
                                                (this.state.valueBankRDNName && this.state.valueBankRDNName === 'permata' && !store.state.hasRDN) ?
                                                    <Form.Row>
                                                        <CustomInput
                                                            col="12"
                                                            required
                                                            name="permata_agree"
                                                            type="checkbox"
                                                            typeCheck="single"
                                                            value={values.permata_agree}
                                                            option={[{ value: 0, label: (<div>Saya telah membaca dan menyetujui Ringkasan Informasi Produk dan Layanan (RIPLAY) Umum RDN PT Bank Permata Tbk yang dapat dilihat <a target="_blank" rel="noopener noreferrer" href="/viewer/permata-rdn-riplay" style={{ 'fontWeight': 'bold', 'fontStyle': 'italic', 'color': '#0172ba', 'textDecoration': 'none', 'paddingBottom': '1px', 'borderBottom': '1px solid transparent', 'transition': 'all 0.5s' }}>{store.dispatch({ type: 'translate', 'text': 'state_here' })}</a></div>) }]}
                                                            handleChange={handleChange}
                                                            isValid={touched.permata_agree && !errors.permata_agree}
                                                            isInvalid={!!errors.permata_agree}
                                                            error={(typeof errors.permata_agree === 'object') ? store.dispatch({ type: 'translate', 'text': errors.permata_agree.type }).toString().replace('$param$', errors.permata_agree.param).replace('$param2$', errors.permata_agree.param2) : store.dispatch({ type: 'translate', 'text': errors.permata_agree })}
                                                        />
                                                    </Form.Row>
                                                    : ''
                                            }

                                            { /* BANK JAGO CONSENT */ }
                                            {
                                                (extractValue(values.rdn_bank) === 'jago') ?
                                                    <Form.Row>
                                                        <Form.Group as={Col} lg={12}>
                                                            <Form.Text className="info" data-testid="jago_info">
                                                                {store.dispatch({ type: 'translate', 'text': 'jago_info' })}
                                                            </Form.Text>
                                                        </Form.Group>
                                                        <CustomInput
                                                            col="12"
                                                            name="jago_agree"
                                                            type="checkbox"
                                                            typeCheck="single"
                                                            value={values.jago_agree}
                                                            option={[{ value: 0, label: store.dispatch({ type: 'translate', 'text': 'jago_agree' }) }]}
                                                            handleChange={handleChange}
                                                            isValid={touched.jago_agree && !errors.jago_agree}
                                                            isInvalid={!!errors.jago_agree}
                                                            error={store.dispatch({ type: 'translate', 'text': errors.jago_agree })}
                                                        />
                                                    </Form.Row>
                                                    : ''
                                            }

                                            { /* CIMB AGREEMENT CHECKBOX */ }
                                            {
                                                (this.state.valueBankRDNName && this.state.valueBankRDNName === 'cimb' && !store.state.hasRDN) ?
                                                    <Form.Row>
                                                        <CustomInput
                                                            col="12"
                                                            required
                                                            name="cimb_agree1"
                                                            type="checkbox"
                                                            typeCheck="single"
                                                            value={values.cimb_agree1}
                                                            option={[{ value: 0, label: store.dispatch({ type: 'translate', 'text': 'cimb_agree1_a' }) + company_name + store.dispatch({ type: 'translate', 'text': 'cimb_agree1_b' }) }]}
                                                            handleChange={handleChange}
                                                            isValid={touched.cimb_agree1 && !errors.cimb_agree1}
                                                            isInvalid={!!errors.cimb_agree1}
                                                            error={(typeof errors.cimb_agree1 === 'object') ? store.dispatch({ type: 'translate', 'text': errors.cimb_agree1.type }).toString().replace('$param$', errors.cimb_agree1.param).replace('$param2$', errors.cimb_agree1.param2) : store.dispatch({ type: 'translate', 'text': errors.cimb_agree1 })}
                                                        />
                                                        <CustomInput
                                                            col="12"
                                                            required
                                                            name="cimb_agree2"
                                                            type="checkbox"
                                                            typeCheck="single"
                                                            value={values.cimb_agree2}
                                                            option={[{ value: 0, label: (<div>{store.dispatch({ type: 'translate', 'text': 'cimb_agree2' })}<a target="_blank" href="/viewer/cimb-kpupr" style={{ 'fontWeight': 'bold', 'fontStyle': 'italic', 'color': '#0172ba', 'textDecoration': 'none', 'paddingBottom': '1px', 'borderBottom': '1px solid transparent', 'transition': 'all 0.5s' }}>{store.dispatch({ type: 'translate', 'text': 'state_here' })}</a></div>) }]}
                                                            handleChange={handleChange}
                                                            isValid={touched.cimb_agree2 && !errors.cimb_agree2}
                                                            isInvalid={!!errors.cimb_agree2}
                                                            error={(typeof errors.cimb_agree2 === 'object') ? store.dispatch({ type: 'translate', 'text': errors.cimb_agree2.type }).toString().replace('$param$', errors.cimb_agree2.param).replace('$param2$', errors.cimb_agree2.param2) : store.dispatch({ type: 'translate', 'text': errors.cimb_agree2 })}
                                                        />
                                                    </Form.Row>
                                                    : ''

                                            }
                                            
                                            {/* Syariah TNC */}
                                            {
                                            (this.props.syariah_stat) ?
                                            <Form.Row>
                                            <CustomInput
                                                            col="12"
                                                            required
                                                            name="syariah_tnc_agree"
                                                            type="checkbox"
                                                            typeCheck="single"
                                                            value={values.syariah_tnc_agree}
                                                            option={[{ value: 0, label: (<div>{store.dispatch({ type: 'translate', 'text': 'syariah_tnc_agree' })} <a target="_blank" href="/viewer/syariah-tnc" style={{ 'fontWeight': 'bold', 'fontStyle': 'italic', 'color': '#0172ba', 'textDecoration': 'none', 'paddingBottom': '1px', 'borderBottom': '1px solid transparent', 'transition': 'all 0.5s' }}>{store.dispatch({ type: 'translate', 'text': 'state_here' })}</a></div>) }]}
                                                            handleChange={handleChange}
                                                            isValid={touched.syariah_tnc_agree && !errors.syariah_tnc_agree}
                                                            isInvalid={!!errors.syariah_tnc_agree}
                                                            error={(typeof errors.syariah_tnc_agree === 'object') ? store.dispatch({ type: 'translate', 'text': errors.syariah_tnc_agree.type }).toString().replace('$param$', errors.syariah_tnc_agree.param).replace('$param2$', errors.syariah_tnc_agree.param2) : store.dispatch({ type: 'translate', 'text': errors.syariah_tnc_agree })}
                                                        />
                                            </Form.Row>
                                            :''
                                        }

                                            <div className={cx('row', styleRegis['wrap-btn'])}>
                                                <div className="container-btn col-md-12 text-center">
                                                    <div className='button-control'>
                                                        <ButtonCustom class="yellow-btn" value={store.dispatch({ type: 'translate', 'text': 'btn_prev' })} onButtonClick={(value) => store.dispatch({ type: 'clickButton', field: 'prev' })} />
                                                        <ButtonCustom id="bank-information-btn" class="blue-btn" value={store.dispatch({ type: 'translate', 'text': 'btn_finish' })} loading={store.state.next_action} type="submit" disabled={store.state.next_action} />
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                        
                                        {/** Modal OTP */}
                                        <ModalOTP uid={store.state.member_id} show={this.state.showModalOTP} handleModalOTP={this.handleModalOTP}/>
                                    </Fragment>
                                )}
                            </Formik>

                            <div>
								<Modal show={this.state.showModalHasRDN} centered={true} contentClassName={style['homepageModalInfo']} size="lg">
									<Modal.Body>
										<div className={style['ModalBodyInner']}>
											<p>Anda telah memiliki akun reguler. Silahkan pilih RDN Syariah untuk melanjutkan pendaftaran akun syariah.</p>
                                            <p>You already have a regular account. Please select a Sharia RDN to continue registering a Sharia account.</p>
										</div>
									</Modal.Body>
									<div className={style['homepageModalInfoFooter']}>
										<Button variant="primary" onClick={() => {this.handleModalHasRDN(false)}}>Lanjutkan / Continue</Button>
									</div>
								</Modal>
							</div>
                            <div>
                                <Modal show={this.state.bcaRiplayModal} centered={true} contentClassName={style['homepageModalInfo']} size="lg">
                                    <Modal.Body>
                                        <div className={style['ModalBodyInner']}>
                                            <p>Ringkasan Informasi Produk dan Layanan (RIPLAY) Umum RDN PT Bank Central Asia Tbk "BCA" dapat diakses pada website resmi BCA https://www.bca.id/rdnbca</p>
                                        </div>
                                    </Modal.Body>
                                    <div className={style['homepageModalInfoFooter']}>
                                        <Button variant="primary" onClick={() => {this.setBcaRiplayModal(false)}}>Lanjutkan</Button>
                                    </div>
                                </Modal>
                            </div>
                            <div>
                                <Modal show={this.state.permataRiplayModal} centered={true} contentClassName={style['homepageModalInfo']} size="lg">
                                    <Modal.Body>
                                        <div className={style['ModalBodyInner']}>
                                            <p>Ringkasan Informasi Produk dan Layanan (RIPLAY) Umum RDN PT Bank Permata Tbk dapat dilihat <a target="_blank" rel="noopener noreferrer" href="/viewer/permata-rdn-riplay">disini</a>.</p>
                                            <p>Dengan menekan tombol <strong>Lanjutkan</strong>, Anda dianggap telah membaca dan menyetujui RIPLAY tersebut.</p>
                                        </div>
                                    </Modal.Body>
                                    <div className={style['homepageModalInfoFooter']}>
                                        <Button variant="primary" onClick={() => {
                                            // RIPLAY 확인 → permata_agree 체크박스 자동 체크 (array [0] 포맷, CustomInput 단일 체크박스 규약)
                                            if (this.formikRef) {
                                                this.formikRef.setFieldValue('permata_agree', [0]);
                                                this.formikRef.setFieldTouched('permata_agree', true);
                                            }
                                            this.setPermataRiplayModal(false);
                                        }}>Lanjutkan</Button>
                                    </div>
                                </Modal>
                            </div>
                            </>
                        )
                    }
                }
            </RootContext.Consumer>
        )
    }
}

export default props => (
    <RootContext.Consumer>
        {
            store => {
                return (
                    <BankAccountForm {...props} cur_bank_name={store.state.registration.rdn_bank} cur_bank_rdn={store.state.registration.rdn_bank} cur_bank_rdn_syariah={store.state.registration.rdn_bank_syariah} syariah_stat={store.state.syariahStat} hasrdnstat={store.state.hasRDN}/>
                )
            }
        }
    </RootContext.Consumer>
)